import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',

  },
  item: {
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
